import { graphql, useStaticQuery } from 'gatsby';

// Better to have a list of common queries in one place than to have the same query repeated in multiple components.
// This also allows us to use the query in providers and pass the data down via context, which is better for performance than having multiple components all run the same query with useStaticQuery.
export const useCrowdRiffQuery = () => {
    const data = useStaticQuery(graphql`
{
    allSmartTagsCrowdRiff(
        filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
    ) {
        edges {
            node {
                id
                hash
                title
                hashtag
                flush
                Audience {
                    object {
                        id
                    }
                }
            }
        }
    }
}
`);
    return { data };
};